import {clientService} from "../network/services/client.service";

export default {
  namespaced: true,
  state: {
    loading: false,
    errors: {
      email: null,
      phone: null,
      password: null,
      country: null,
      Auth_register: null,
      "address.country": null
    }
  },
  mutations: {
    SET_LOADING (state, payload) {
      state.loading = !!payload;
    },
    SET_ERROR(state, {field, error}) {
      if (field) {
        state.errors[field] = error;
        return;
      }
      throw new Error(`Field ${field} does not exist in registration store`);
    },
    CLEAN_ERRORS (state) {
      Object.keys(state.errors).forEach((k) => {
        state.errors[k] = null;
      })
    }
  },
  actions: {
    async register (context, data) {
      context.commit('SET_LOADING', true);
      context.commit('CLEAN_ERRORS');
      const response = await clientService.createAccount(data);
      if (response.response.errors && response.response.errors.length > 0) {
        for (const error of response.response.errors) {
          context.commit('SET_ERROR', {field: Array.isArray(error.path) ? error.path.join('_') : error.path, error: error.message});
          if (error.code === 101) { // FieldException
            context.commit('SET_ERROR', {field: error.error.path, error: error.error.fieldError});
          }
        }
      }
      context.commit('SET_LOADING', false);
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/registration.store.js